import React, { useState } from 'react';
import axios from 'axios';
import SuperAdminLayout from '../../../components/hostel/superadmin/SuperAdminLayout';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const BackupRestore = ({ onNavigate, userInfo }) => {
    const [loading, setLoading] = useState(false);

    const handleDownload = async (format) => {
        try {
            setLoading(true);

            const response = await axios.get(`${API_URL}/superadmin/backup/download`, {
                params: { format },
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            const extension = format === 'sql' ? 'sql.gz' : 'zip';
            link.setAttribute('download', `sanaka_backup_${new Date().toISOString().slice(0, 10)}.${extension}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Download failed:', error);
            alert('Failed to download backup. Please check console.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <SuperAdminLayout
            onNavigate={onNavigate}
            userInfo={userInfo}
            activePage="hostel-superadmin-backup"
            pageTitle="Database Backup"
            icon="💾"
        >
            <style>{`
                .backup-card-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
                    gap: 24px;
                }

                .backup-card {
                    background: white;
                    border-radius: 16px;
                    padding: 32px;
                    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    text-align: center;
                    border: 1px solid #e2e8f0;
                    transition: transform 0.2s;
                }

                .backup-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
                }

                .icon-circle {
                    width: 80px;
                    height: 80px;
                    background: #e0e7ff;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 24px;
                    font-size: 32px;
                    color: #4f46e5;
                }

                .card-title {
                    font-size: 20px;
                    font-weight: 700;
                    color: #1e293b;
                    margin-bottom: 8px;
                }

                .card-desc {
                    color: #64748b;
                    font-size: 14px;
                    margin-bottom: 24px;
                    line-height: 1.5;
                }

                .btn-download {
                    background: #4f46e5;
                    color: white;
                    padding: 12px 24px;
                    border-radius: 12px;
                    border: none;
                    font-weight: 600;
                    cursor: pointer;
                    width: 100%;
                    transition: background 0.2s;
                }

                .btn-download:hover {
                    background: #4338ca;
                }

                .btn-download:disabled {
                    background: #94a3b8;
                    cursor: not-allowed;
                }
            `}</style>

            <div className="backup-card-grid">
                {/* SQL Backup Card */}
                <div className="backup-card">
                    <div className="icon-circle">🗄️</div>
                    <h3 className="card-title">Full SQL Backup</h3>
                    <p className="card-desc">
                        Download a complete backup of the entire database structure and data in SQL format.
                        Best for full system restoration.
                        <br /><small>(Compressed as .sql.gz)</small>
                    </p>
                    <button
                        className="btn-download"
                        onClick={() => handleDownload('sql')}
                        disabled={loading}
                    >
                        {loading ? 'Processing...' : 'Download SQL Backup'}
                    </button>
                </div>

                {/* CSV Backup Card */}
                <div className="backup-card">
                    <div className="icon-circle">📊</div>
                    <h3 className="card-title">CSV Data Export</h3>
                    <p className="card-desc">
                        Download all key tables as individual CSV files.
                        Best for data analysis, reporting, and external processing.
                        <br /><small>(Compressed as .zip)</small>
                    </p>
                    <button
                        className="btn-download"
                        onClick={() => handleDownload('csv')}
                        disabled={loading}
                    >
                        {loading ? 'Processing...' : 'Download CSV Backup'}
                    </button>
                </div>
            </div>
        </SuperAdminLayout>
    );
};

export default BackupRestore;
